import { useDocumentVisibility, useTimeoutFn, watchOnce } from '@vueuse/core';
import type { NotificationHandle } from 'element-plus';

export function useNotificationVisibility(handle: NotificationHandle, duration: number): void {
  const originalClose = handle.close;

  const { start, stop } = useTimeoutFn(() => handle.close(), duration, { immediate: false });

  watchOnce(useDocumentVisibility(), (state) => {
    if (state === 'visible') start();
  });

  handle.close = () => {
    stop();
    originalClose();
  };
}
